module.exports = __webpack_public_path__ + "img/17861_L.426188c8.png";